import React from 'react';
import { useNavigate } from "react-router-dom";
import {Box, Grid, Button} from '@material-ui/core';
import { Divider } from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import LinearProgress from '@mui/material/LinearProgress';
import Alert from '../components/Alert';
import Authorization from '../components/Authorization';
import InvoiceSettingSave from './InvoiceSettingSave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefAlert = React.useRef();
	const childRefSave = React.useRef(); 
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [dataLoading, setDataLoading] = React.useState(true);
	
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [alertMessage, setAlertMessage] = React.useState("");

	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){
			getApiData();
		}
	}, [userObj]);

	async function getApiData(){ 
		  let apiUrl=API_URL+'/crm-invoices-setting';
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);
					setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
					
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setAlertMessage(""+error);			
          		childRefAlert.current.handleClickOpen();	
				return false;
		  	})	
	}

	function saveData(){
		if(rows && rows.length>0){
			setDataObj(rows[0]);
		}else{
			setDataObj(null);
		}

		childRefSave.current.handleClickOpen();
	}

	function updatedList(list) {
		setRows(list);
	}

	
	return (
		<div> 
				<MetaTags>
            		<title>Invoice Setting</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Invoice Setting" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box ml={9} mr={9} mt={3} mb={20} >
						<Grid container spacing={2} >

						{(rows && rows.length>0)?<>	
							<Grid item md={3} xs={12} style={{verticalAlign: 'top'}} >
									Company Name<br/>
									Address
							</Grid>
							<Grid item md={9} xs={12} style={{verticalAlign: 'top'}} >
								<div style={{whiteSpace: "pre-wrap"}}>{rows[0].address}</div>
							</Grid>
							<Grid item md={12} xs={12}  >
								<Divider />
							</Grid>
							
							<Grid item md={3} xs={12} style={{verticalAlign: 'top'}} >
								Phone<br/>
								Email<br/>
								Website<br/>
							</Grid>
							<Grid item md={9} xs={12} style={{verticalAlign: 'top'}} >
								<div style={{whiteSpace: "pre-wrap"}}>{rows[0].phone}</div>
							</Grid>
							<Grid item md={12} xs={12} >
								<Divider />
							</Grid>
							
							<Grid item md={3} xs={12} style={{verticalAlign: 'top'}} >
								Notes
							</Grid>
							<Grid item md={9} xs={12} style={{verticalAlign: 'top'}} >
								<div style={{whiteSpace: "pre-wrap"}}>{rows[0].notes}</div>
							</Grid>
							<Grid item md={12} xs={12} >
								<Divider />
							</Grid>
							
							<Grid item md={3} xs={12} style={{verticalAlign: 'top'}} >
								Company Logo
							</Grid>
							<Grid item md={9} xs={12} style={{verticalAlign: 'top'}} >
								{(rows[0].logoUrl && rows[0].logoUrl.length>0)?<img src={rows[0].logoUrl} style={{maxHeight:100, maxWidth: 200}}  />:null}

								{(privileges && privileges.indexOf("update")>-1)?
									<div style={{marginTop: 25}}>
										<Button onClick={() => {saveData()}} size="small" color="primary" variant="outlined" >Edit</Button>
									</div>
								:null}

							</Grid>
						</>:null}	


						</Grid>
					</Box>

				

				</Box>
				


				<Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />	
				<InvoiceSettingSave dataObj={dataObj} userObj={userObj} updatedList={updatedList} ref={childRefSave} />			
				<Authorization ref={childRefAuthorization} />			
		</div>	
	);
  }